import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useGetSpaces } from '@/entities/teamspace/model/useGetSpaces';

import { Loader } from '@/shared/ui/Loader';

export const HomeRedirect = () => {
  const navigate = useNavigate();
  const { data: spaces, isLoading } = useGetSpaces(true);

  useEffect(() => {
    if (!isLoading && spaces?.length) {
      const spaceForRedirect = spaces[0];

      navigate(`/spaces/${spaceForRedirect?.id}`, { replace: true });
    }
  }, [spaces, isLoading, navigate]);

  return <Loader />;
};
